<template>
  <small v-if="content" ref="component" class="caption" :class="padding">
    <span
      class="caption-wrap"
      :class="{ 'is--clamped': maxLines }"
      :style="maxLines ? { '--webkit-line-clamp': maxLines } : {}"
    >
      {{ content }}
    </span>
  </small>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const component = ref();

interface IProps {
  content?: string;
  maxLines?: number;
  hasPadding?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  content: undefined,
  maxLines: undefined,
  hasPadding: false,
});

const padding = props.hasPadding ? 'is--padded' : '';
</script>

<style lang="postcss" scoped>
.caption {
  --webkit-line-clamp: unset;

  @add-mixin label-sm;

  display: block;
  color: hsl(var(--color-primary-500));
  margin: var(--unit-8) 0;

  @media (--lg-viewport) {
    --caption-margin: var(--unit-12);
  }

  &.is--padded {
    @media (--sm-viewport) {
      margin-left: var(--unit-18);
      margin-right: var(--unit-18);
    }
  }
}

.caption-wrap {
  &.is--clamped {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: var(--webkit-line-clamp);
    line-clamp: var(--webkit-line-clamp);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
